import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PortalDataContext = /*#__PURE__*/createContext(null);
export function PortalDataProvider({
  children,
  initialData
}) {
  const [portalData, setPortalData] = useState(initialData !== null && initialData !== void 0 ? initialData : null);
  return /*#__PURE__*/_jsx(PortalDataContext.Provider, {
    value: {
      portalData,
      setPortalData
    },
    children: children
  });
}
export function usePortalData() {
  const context = useContext(PortalDataContext);
  if (!context) {
    throw new Error('usePortalData must be used within a PortalProvider');
  }
  return context;
}
export function useBrandSettings() {
  var _portalData$context;
  const {
    portalData
  } = usePortalData();
  return portalData === null || portalData === void 0 || (_portalData$context = portalData.context) === null || _portalData$context === void 0 ? void 0 : _portalData$context.brandSettings;
}
export function useFavicon() {
  var _brandSettings$primar;
  const brandSettings = useBrandSettings();
  return (_brandSettings$primar = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryFavicon) !== null && _brandSettings$primar !== void 0 ? _brandSettings$primar : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.favicon;
}
export function useLogo() {
  var _brandSettings$primar2;
  const brandSettings = useBrandSettings();
  return (_brandSettings$primar2 = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryLogo) !== null && _brandSettings$primar2 !== void 0 ? _brandSettings$primar2 : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logo;
}